import { en } from './en'
import { fr } from './fr'

export const networkPage = { en, fr }
